<template>
  <div>
    <h3 class="tw-text-center title-wizard">{{title}}</h3>
    <p class="tw-text-center subtitle-wizard">{{subtitle}}</p>
  </div>
</template>

<script>
export default {
    props: ['title', 'subtitle']
};
</script>

<style lang="scss">
.title-wizard{
  font-size: 30px;
  color: #be0b22;
  font-weight: normal;
  letter-spacing: 0.64px;
  line-height: normal;
  margin-bottom: 10px;
  @media(max-width: 992px){
    font-size: 25px;
  }
}
.subtitle-wizard{
  font-size: 16px;
}
</style>
